import script from "./CommonButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonButton.vue?vue&type=script&lang=ts&setup=true"

import "./CommonButton.vue?vue&type=style&index=0&id=468db508&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468db508"]])

export default __exports__